import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { AfeGridPanel } from "./AfeGridPanel";
import { CostPanel } from "./CostPanel";

/**
 * Cost & AFE screen — the standalone route. Resolves the current well's active
 * event and renders the AFE line grid (account × program-step budgets, accrual,
 * variance) above the plan-vs-actual + cost-pivot panel (also embedded in the
 * DDR Cost tab). Each panel owns its own loading / empty / error state.
 */
export function CostAfe() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("cost.title")}</h1>
        <p className="subtitle">{well ? `${well.commonName} · ${well.field}` : t("well.notSelected")}</p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {activeEvent ? (
          <>
            <AfeGridPanel eventId={activeEvent.id} />
            <div style={{ marginTop: 22 }}>
              <CostPanel eventId={activeEvent.id} />
            </div>
          </>
        ) : null}
      </QueryState>
    </div>
  );
}
